import { createLog, type LogLevel } from "@/api/log.service";
import { getLoggedUser } from "@/utils/sessionUtils";

export const useLogger = () => {
  const user = getLoggedUser();

  const log = (
    event_type: string,
    payload: Record<string, any>,
    entity_name?: string,
    entity_id?: string,
    level: LogLevel = 'info'
  ) => {
    createLog({
      event_type,
      entity_name,
      entity_id,
      payload,
      level,
      actor_id: user?.id
    });
  };

  return { log };
};